(function(window, document, mL_config, mL, mL_errors, mL_events) {
    "use strict";

    var key = 'mlahart_globals';

    if (!mL_config) throw new Error('The mL_config global is not available');
    if (!mL_errors) throw new Error('The mL_errors global is not available');
    if (!mL) throw new Error('The mL global is not available');

    mL.user = window.mL.user || {};

    var md5_loaded = false;
    var md5_email_value = false;


    function loadMd5(next) {
        //console.log('loadMd5-2', typeof next);
        var el = document.createElement('script');
        el.onload = function(ev) {
            console.log('onload', typeof next);
            md5_loaded = true;
            if (next) next();
        };
        el.src = '/static/md5.js';
        if (document && document.body) document.body.appendChild(el);
    }

    function get_hash(inp) {
        if (!CryptoJS || !CryptoJS.MD5) return false;
        return CryptoJS.MD5(inp.toLowerCase()).toString();
    }

    function set_md5_email(inp, cb) {
        var hash = get_hash(inp);
        //console.log('hash', hash);
        if (hash && !md5_email_value) {
            md5_email_value = hash;
            //console.log('md5_email_value', md5_email_value);
        }
        if (cb) cb();
    }

    function set_email(inp, cb) {
        if (md5_loaded) return set_md5_email(inp, cb);
        loadMd5(function() {
            return set_md5_email(inp, cb);
        });
    }

    function md5_email(inp, cb) {
        //console.log('inp', inp);
        if (inp) return set_email(inp, cb);
        return md5_email_value;
    }

    /////////////////////////////////////////////////////////////////////////////////
    /// Globals Begins


    mL.is_checkout = mL_config.is_checkout;
    mL.is_dev = mL_config.is_dev;
    mL.is_scraper = mL_config.is_scraper;
    mL.pageviews = 1;

    if (mL_config.is_scraper) mL.no = true;

    try {
        mL.is_app = !!(document.documentElement.getAttribute('data-ng-app'));
    } catch (err) { mL_errors(err); }


    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }


    function getParameter(href, key, val) {
        if (!href || !key) return false;
        val = href.match(new RegExp('[?&]' + key + '=([^&#]*)'));
        return (val && val[1]) ? key + '=' + val[1] + '&' : '';
    }

    function getParameters() {
        var obj = false;
        var href = window.location.href;
        var str = false;
        var arr = [];

        if (href.indexOf("?") !== -1) {
            str = href.split("?")[1];
        }

        if (str && str.indexOf("&") !== -1) {
            arr = str.split("&");
        }

        if (arr.length > 0) {
            obj = {};
            for (var i = 0; i < arr.length; i += 1) {
                if (arr[i].indexOf("=") !== -1) {
                    obj[arr[i].split("=")[0]] = arr[i].split("=")[1];
                } else {
                    obj[arr[i]] = "";
                }
            }
        } else if (str.length) {
            obj = {};
            obj[str.split("=")[0]] = str.split("=")[1];
        }
        return obj;
    }

    function processAnyForm(obj, callback) {
        var req, o;
        obj.timestamp = new Date().getTime().toString();
        obj.url = window.location.href;
        obj.referrer = (document.referrer) ? document.referrer : null;
        if (window.document.cookie) obj.cookies = window.document.cookie;
        if (mL_config.ls) obj.localStorage = localStorage;
        if (!obj.gaid && mL.gaid) obj.gaid = mL.gaid;

        o = JSON.stringify(obj);
        req = new XMLHttpRequest();
        req.open("POST", "/TJB/api/form.ss", true);
        req.setRequestHeader("Content-type", "application/json");
        req.onreadystatechange = function() {
            if (req.readyState === 4) {
                try {
                    if (typeof callback === 'function') callback(req.status, req.responseText);

                    var _event = obj._event || 'form.submit';

                    var _data = {
                        event: _event,
                        data: obj,
                        res_status: req.status,
                        res_text: req.responseText
                    };

                    mL_events.publish(_event, _data);


                } catch (err) { mL_errors(err); }
            }
        };
        req.send(o);

    }


    function processTheFooterForm(name) {
        if (name !== 'footer') return console.log(name + ' form does not exist');
        var isEmail = /.+\@.+\..+/;

        var wrapEl = document.getElementById("ftFrm");
        var emailEl = document.getElementById("ftInp");
        var email = emailEl.value;
        var valid = isEmail.test(email);
        if (valid) {
            processAnyForm({ email: email, form: 'Footer Form', _event: 'form.subscribe' });

            wrapEl.setAttribute('class', 'success');
            emailEl.setAttribute('placeholder', 'Thank You for Signing Up!');
            emailEl.value = '';
        } else {
            wrapEl.setAttribute('class', 'error');
        }
    }


    function sync_it() {
        var el_src, new_el;
        try {
            el_src = SC.SESSION.touchpoints.serversync.replace('http://www.mlahart.com/', 'https://www.mlahart.com/');
            new_el = document.createElement('img');
            new_el.src = el_src;
            new_el.setAttribute('style', 'display:none;');
            if (document && document.body) document.body.appendChild(new_el);
        } catch (err) { mL_errors(err); }
    }

    window.tjb = window.tjb || {};
    window.tjb.processForm = processTheFooterForm;
    window.tjb.form = processAnyForm;

    mL.getParams = getParameters;
    mL.params = mL.getParams() || {};

    if (mL.params.no) {
        mL.no = true;
        mL_config.do_not_track = true;
    }

    function disable_code(str) {
        if (str === 'all') {
            mL_config.tags = {};
            mL_config.reviews.active = false;
            return;
        }

        var to_disable = str.split(',');
        var i = 0,
            l = to_disable.length;

        for (i; i < l; i += 1) {
            if (mL_config.tags[to_disable[i]]) {
                delete mL_config.tags[to_disable[i]];
            } else if (to_disable[i] === 'reviews') {
                mL_config.reviews.active = false;
            }
        }
    }

    if (mL.params.disable && mL_config) {
        try {
            disable_code(mL.params.disable);
        } catch (err) { mL_errors(err); }
    }

    mL.getParam = getParameter;
    mL.readCookie = readCookie;
    mL.ls = mL_config.ls;

    mL.sync_it = sync_it;
    mL.post_login_sync = false;
    mL.actions = function(obj) {
        console.log(obj);
    };

    mL.md5_email = md5_email;

    mL.user.mlahart_uid = function() {
        return readCookie('mlahart_uid');
    };


    try {
        mL.device_type = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
    } catch (err) {}


    var active_version = false;

    function init_active_version() {
        var ids = ['mlahart_app', 'mlahart_fw', 'mlahart_app_css', 'mlahart_fw_css', 'mlahart_shops', 'mlahart_global', 'mlahart_global_session'];
        var i = 0;
        var l = ids.length;
        var ver_obj = {};
        var ver_arr = [];

        function get_ver(id) {
            var el = document.getElementById(id);
            var version = el && el.getAttribute('data-version');
            if (version) ver_obj[id] = version;
        }

        for (i; i < l; i += 1) {
            get_ver(ids[i]);
        }        

        if (ver_obj.mlahart_fw) ver_arr.push(ver_obj.mlahart_fw);
        if (ver_obj.mlahart_app) ver_arr.push(ver_obj.mlahart_app);
        if (ver_obj.mlahart_global) ver_arr.push(ver_obj.mlahart_global);

        ver_obj.text = ver_arr.join('.') || 'unknown';

        //console.log('ver_obj', ver_obj);
        active_version = ver_obj;
        return active_version;
    }

    mL.version = function() {
        return (!active_version) ? init_active_version() : active_version;
    };

    mL.add_tracker = function(url, tagid, el, onload) {
        if (!url || !tagid || document.getElementById(tagid) || !document.head) return;
        el = document.createElement('script');
        el.type = 'text/javascript';
        el.id = tagid;
        el.defer = true;
        el.src = url;
        if (onload && typeof onload === 'function') {
            el.onload = onload;
        }
        document.head.appendChild(el);
    };

    (function(mL, mL_config, mL_errors) {
        var active_shop = false;
        var shop_lskey = 'active_shop';
        var req_fields = ['shop_name', 'shop_urlc', 'shop_lp_code', 'shop_color', 'shop_type'];

        function is_valid(data_in) {
            var i = 0,
                l = req_fields.length,
                valid = true;
            for (i; i < l && valid; i += 1) {
                if (!data_in[req_fields[i]]) {
                    valid = false;
                }
            }
            return valid;
        }


        function get_local_storage() {
            if (!mL_config.ls) return false;

            var res_str = localStorage.getItem(shop_lskey);

            if (!res_str) return false;

            var res_obj = JSON.parse(res_str);

            if (!is_valid(res_obj)) return false;

            active_shop = res_obj;
            return active_shop;
        }

        function set_shop(data_in) {
            if (is_valid(data_in)) {
                localStorage.setItem(shop_lskey, JSON.stringify(data_in));
                active_shop = data_in;
                return true;
            }
            return false;
        }


        function get_shop() {
            return (active_shop) ? active_shop : get_local_storage();
        }

        function shop(data_in) {
            return (!data_in) ? get_shop() : set_shop(data_in);
        }

        get_local_storage();

        mL.user = mL.user || {};
        mL.user.shop = shop;

        // mL_config.shop({'shop_name': 'required', 'shop_urlc': 'required', 'shop_lp_code': 'required', 'shop_color': 'required', 'shop_type': 'required'})

    }(mL, mL_config, mL_errors));


}(window, document, window.mL_config, window.mL, window.mL_errors, window.mL_events));


/*

function sync_req(url) {
    var req;
    req = new XMLHttpRequest();
    req.open("GET", url, true);
    req.setRequestHeader("Content-type", "application/json");
    req.onreadystatechange = function() {
        if (req.readyState === 4) {
            window.mL = window.mL || {};
            try {
                mL.sync = JSON.parse(req.responseText);
            } catch (err) {
                 mL_errors(err); 
                mL.sync = { error: err };
            }
        }
    };
    req.send();
}

    
function syncWithServer() {
    //console.log('syncWithServer');
    var params = ['vid', 'chrole', 'ck', 'cktime', 'cart', 'sj', 'leadsource', 'partner', 'promocode'];
    var url = window.location.origin + '/ns_api/mlahart_global.ss?'; // + getParameter(HREF, 'promocode') + getParameter(HREF, 'leadsource') + getParameter(HREF, 'partner');
    for (var i = 0; i < params.length; i += 1) {
        url += getParameter(HREF, params[i]);
    }
    if (url && url.indexOf('=') !== -1) sync_req(url);
}
*/